module.exports = __webpack_public_path__ + "viamonte-24268f1432e44f99c49f4ce509c15b2a.webp";